import React, { FC } from 'react';
import Helmet from 'react-helmet';
import { CDN_ORIGIN_ENDPOINT } from '../../../../../shared/cdn';
import { SHARE_IMAGE_URL } from './headConstants';

type Props = {
  title?: string;
  description?: string;
};

export const HeadSocial: FC<Props> = ({ title, description }) => (
  <Helmet>
    {/* Pinterest */}
    <meta name="p:domain_verify" content="9efbfd11fa3250606d957dac15892d4f" />
    {/* Facebook */}
    <meta property="fb:app_id" content="731122283690395" />
    {/* Twitter */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@Doctrine" />
    <meta name="twitter:creator" content="@Doctrine" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description}></meta>
    <meta
      name="twitter:image"
      content={`${CDN_ORIGIN_ENDPOINT}${SHARE_IMAGE_URL}`}
    />
  </Helmet>
);
